import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-payments-new-gateway-creation-card',
  templateUrl: './payments-new-gateway-creation-card.component.html',
  styleUrls: ['./payments-new-gateway-creation-card.component.scss']
})
export class PaymentsNewGatewayCreationCardComponent implements OnInit {

  @Input() providers;
  @Input() types;
  showButton: boolean;
  newGatewayForm = new FormGroup({
    image: new FormControl(null, Validators.required),
    active: new FormControl(true, Validators.required),
    name: new FormControl(null, Validators.required),
    type: new FormControl(null, Validators.required),
    provider: new FormControl(null, Validators.required),
    properties: new FormControl(null, Validators.required),
    invoiceprefix: new FormControl(null),
    accessOnsite: new FormControl(false),
    accessOnline: new FormControl(false)
  });
  addNewGatewaySubscription: Subscription;

  constructor(private spinnerService: SpinnerService,
              private snackbarService: SnackBarService,
              private router: Router,
              private dialog: MatDialog,
              private paymentsService: PaymentsService,
              private activatedRoute: ActivatedRoute) {
    this.showButton = true;
  }

  ngOnInit() {
  }

  public cancelGateway() {
    this.router.navigate(['../gateways'], { relativeTo: this.activatedRoute.parent });
  }

  public addNewGateway() {
    this.showButton = false;
    this.spinnerService.show('gateway-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewGatewaySubscription = this.paymentsService.addNewGateway(this.newGatewayForm).subscribe(
        (res) => {
          this.showButton = true;
          this.spinnerService.hide('gateway-new-spinner');
          this.snackbarService.open('gateways-page.snackbar messages.add gateway success', 'success');
          this.router.navigate(['../gateways'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('gateway-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.newGatewayForm.get('image').valid) {
      return 'gateways-page.snackbar messages.image error';
    } else if (!this.newGatewayForm.get('name').valid) {
      return 'gateways-page.snackbar messages.name error';
    } else if (!this.newGatewayForm.get('type').value) {
      return 'gateways-page.snackbar messages.selected type gateway error';
    } else if (!this.newGatewayForm.get('provider').value) {
      return 'gateways-page.snackbar messages.selected provider gateway error';
    } else {
      return true;
    }
  }

  public keyvalueOutputChanged(e) {
    this.newGatewayForm.patchValue({
      properties: e
    });
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.newGatewayForm.patchValue({
            image: result[0].Url
          });
        }
      });
  }
}
